
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AnnuityItemsViewModel, I_AnnuityItemsViewModel } from '../models/annuity-view.model';
import { IAMPSubscriptionDetail, AMPSubscriptionDetailsItemViewModel, AMPubscriptionModel, IAdobeCustomer, IAMPCustomerDetailsViewModel, IAdobeReseller, GetAMPSubscription, IAMPAnnuityItemsViewModel, IAMPModifySubscriptionResponse, IAMPAssociationResponse, IAMPTransferResponse, IAdobeMigrationResponse, IAMPResellerAssociationRequest, IAdobeCustomesForQuoting, I_Adobe_MarketPlaceMigration_Preview } from '../models/amp.model';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { DickerSelectListItem, TenantResponse } from '../models/check-out.model';
import { ApiResponse } from '../models/api-response.model';

@Injectable()
export class AdobeService {
  private controller = 'Manage';

  public extra3YCOption: string;
  public refetchAMPItemsView$: Subject<void> = new Subject<void>();
  public refetchAMPTenantDetailView$: Subject<void> = new Subject<void>();

  private watchAMPResellerId = new BehaviorSubject<string>('');
  public getCurrentAMPResellerId = this.watchAMPResellerId.asObservable();
  public setCurrentAMPResellerId(id: string) {
    this.watchAMPResellerId.next(id);
  }

  private watchCurrentAMPSubscriptions = new BehaviorSubject<GetAMPSubscription[]>([]);
  public getCurrentAMPSubscriptions = this.watchCurrentAMPSubscriptions.asObservable();
  public setCurrentAMPSubscriptions(value: GetAMPSubscription[]) {
    this.watchCurrentAMPSubscriptions.next(value);
  }

  private watchCurrentAMPCustomersForQuotes = new BehaviorSubject<IAdobeCustomesForQuoting[]>(null);
  public getCurrentAMPCustomersForQuotes = this.watchCurrentAMPCustomersForQuotes.asObservable();
  public setCurrentAMPCustomersForQuotes(value: IAdobeCustomesForQuoting[]) {
    this.watchCurrentAMPCustomersForQuotes.next(value);
  }

  
  public AMPSubscriptionSimpleView = new BehaviorSubject<GetAMPSubscription>(null);
  public currentAMPSubscriptionSimpleView = this.AMPSubscriptionSimpleView.asObservable();

  private watchAMPPendingSubscriptions = new BehaviorSubject<IAMPAnnuityItemsViewModel[]>([]);
  public currentPendingAMPSubscriptions = this.watchAMPPendingSubscriptions.asObservable();
  public monitorAMPPendingSubscriptions(pendingList: IAMPAnnuityItemsViewModel[]): void {
    this.watchAMPPendingSubscriptions.next(pendingList);
  }

  private AMPCustomerdetailsSubject = new BehaviorSubject<IAMPCustomerDetailsViewModel>(null);
  currentAMPCustomerDetailsWatch = this.AMPCustomerdetailsSubject.asObservable();
  public monitorAMPCustomerDetailsChange(details: IAMPCustomerDetailsViewModel): void {
    this.AMPCustomerdetailsSubject.next(details);
  }

  private EligibleOffersSubject = new BehaviorSubject<any>(null);
  public currentEligibleOffersWatch = this.EligibleOffersSubject.asObservable();
  public monitorcurrentEligibleOffers(offers: any): void {
    this.EligibleOffersSubject.next(offers);
  }

  constructor(private http: HttpClient, private authService: AuthService) { }



  public createAdobeReseller(inputModel: IAdobeReseller): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.controller}/CreateAdobeReseller`, inputModel)
      .pipe(catchError(this.authService.handleError));
  }

  public createAMPTenant(inputData: IAdobeCustomer): Observable<TenantResponse> {
    return this.http.post<TenantResponse>(`${this.controller}/CreateAMPTenant`, inputData)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPCustomerDetails(tenantId: string): Observable<IAMPCustomerDetailsViewModel> {
    return this.http
      .get<IAMPCustomerDetailsViewModel>(this.controller + '/GetAMPCustomerDetails?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  public updateAMPTenant(inputData: IAdobeCustomer): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.controller}/UpdateAMPTenant`, inputData)
      .pipe(catchError(this.authService.handleError));
  }

  public createOrCancelAMPSubscription(model: AMPubscriptionModel[]): Observable<IAMPModifySubscriptionResponse[]> {
    return this.http
      .post<IAMPModifySubscriptionResponse[]>(this.controller + '/CreateOrCancelAMPSubscription', model)
      .pipe(catchError(this.authService.handleError));
  }

  public createAMPSubscriptionScheduled(model: AMPubscriptionModel[]): Observable<IAMPModifySubscriptionResponse[]> {
    return this.http
      .post<IAMPModifySubscriptionResponse[]>(this.controller + '/CreateAMPSubscription_Scheduled', model)
      .pipe(catchError(this.authService.handleError));
  }
  
  downloadExcelAbobeConfirmProducts(
    model: AMPubscriptionModel[],
    action: string,
    details: any
  ): Observable<any> {
    const custDetails = encodeURIComponent(JSON.stringify(details));
    const url =
      this.controller +
      `/downloadExcelAbobeConfirmProducts?action=${action}&custdetails=${custDetails}`;
  
    return this.http.post(url, model, {
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      },
    }).pipe(
      catchError(this.authService.handleError)
    );
  }
  
  
  public getAMPItemsView(tenantId: string, anniversaryDate? : string): Observable<AMPSubscriptionDetailsItemViewModel> {
    return this.http
      .get<AMPSubscriptionDetailsItemViewModel>(this.controller + '/GetAMPItemsView?tenantId=' + tenantId + '&anniversaryDate=' + anniversaryDate)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPitems(tenantId: string, subscriptionType: string, effectiveDate: string): Observable<I_AnnuityItemsViewModel[]> {
    return this.http.get<I_AnnuityItemsViewModel[]>(this.controller + '/GetAMPitems?tenantId=' + tenantId
      + '&subscriptionType=' + subscriptionType
      + (effectiveDate ? ('&effectiveDate=' + effectiveDate) : '')
    )
      .pipe(catchError(this.authService.handleError))
      .pipe(map((items) => items.map(item => new AnnuityItemsViewModel(item))));
  }

  public getAMPItemCategories(marketSegment: string): Observable<DickerSelectListItem[]> {
    return this.http.get<DickerSelectListItem[]>(this.controller + '/GetAMPItemCategories?marketSegment=' + marketSegment)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPSubscriptionDetail(resellerId: string, subscriptionId: string): Observable<IAMPSubscriptionDetail> {
    return this.http.get<IAMPSubscriptionDetail>(this.controller + '/GetAMPSubscriptionDetail?tenantId=' + resellerId + '&subscriptionId=' + subscriptionId)
      .pipe(catchError(this.authService.handleError));
  }

  public updateAMPRenewal(resellerId: string, subscriptionId: string, detail: IAMPSubscriptionDetail): Observable<IAMPSubscriptionDetail> {
    return this.http.post<IAMPSubscriptionDetail>(this.controller + '/UpdateAMPRenewal?tenantId=' + resellerId + '&subscriptionId=' + subscriptionId, detail)
      .pipe(catchError(this.authService.handleError));
  }

  public AMPAssociateReseller(request: IAMPResellerAssociationRequest): Observable<IAMPAssociationResponse | ApiResponse> {
    return this.http.post<IAMPAssociationResponse | ApiResponse>(this.controller + '/AMPAssociateReseller', request)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPCustomerAssociations(resellerId: string): Observable<IAMPAssociationResponse[]> {
    return this.http.get<IAMPAssociationResponse[]>(this.controller + '/GetAMPAssociatResellerDetails?resellerId=' + resellerId)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPOrdersByCustomer(tenantId: string, offerId: string, startDate: string, endDate = '', history = false): Observable<IAMPAssociationResponse[]> {
    return this.http.get<IAMPAssociationResponse[]>(this.controller + '/GetAMPOrdersByCustomer?tenantId=' + tenantId + '&offerId=' + offerId +'&startDate=' + startDate + (endDate ? '&endDate=' + endDate : '') + (history ? '&orderType=' : ''))
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPResellerDetails(resellerId: string): Observable<IAdobeReseller> {
    return this.http.get<IAdobeReseller>(this.controller + '/GetAMPResellerDetails?resellerId=' + resellerId)
      .pipe(catchError(this.authService.handleError));
  }

  public updateAMPReseller(resellerId: string, updatedData: IAdobeReseller): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.controller}/UpdateAMPReseller?resellerId=` + resellerId, updatedData)
      .pipe(catchError(this.authService.handleError));
  }

  public AMPSubscriptionsTransferPreview(membershipId: string, ignoreOrderReturn: boolean, expireOpenPas: boolean) : Observable<any> {
    return this.http.get<any>(this.controller + '/AMPSubscriptionsTransferPreview?membershipId=' + membershipId +
      '&ignore_order_return=' + ignoreOrderReturn +
      '&expire_open_pas=' + expireOpenPas
    )
      .pipe(catchError(this.authService.handleError));
  }
    
  public AMPSubscriptionsBulkTransferPreview(file: any): Observable<any> {
    return this.http.post<any>(this.controller + '/AMPSubscriptionsBulkTransferPreview', file)
  }
  
  public getAdobeMigrationData(action: string): Observable<IAdobeMigrationResponse[] | ApiResponse> {
    return this.http.get<IAdobeMigrationResponse[] | ApiResponse>(this.controller + '/GetAdobeMigrationData?pageView=' + action)
      .pipe(catchError(this.authService.handleError));
  }

  public AMPTransferSubscriptions(resellerId: string, membershipId: string, ignoreOrderReturn: boolean, expireOpenPas: boolean): Observable<IAMPTransferResponse | ApiResponse> {
    return this.http.get<IAMPTransferResponse | ApiResponse>(this.controller + '/AMPTransferSubscriptions?resellerId=' + resellerId +
      '&membershipId=' + membershipId +
      '&ignore_order_return=' + ignoreOrderReturn +
      '&expire_open_pas=' + expireOpenPas
    )
      .pipe(catchError(this.authService.handleError));
  }
  public AMPBulkTransferSubscriptions(resellerId: string,file: any): Observable<IAMPTransferResponse | ApiResponse> {
    return this.http.post<IAMPTransferResponse | ApiResponse>(this.controller + '/AMPBulkTransferSubscriptionsNew?resellerId=' + resellerId , file)
      .pipe(catchError(this.authService.handleError));
  }
  
  public getAMPLicensesPendingPartnerOrderNotification(resellerId: string): Observable<any> {
    return this.http.get<any>(this.controller + '/GetAMP_Licenses_Pending_Partner_Order_Notification?resellerId=' + resellerId)
      .pipe(catchError(this.authService.handleError));
  }

  public getAMPLicensesPendingPartnerOrders(tenantId: string): Observable<any> {
    return this.http.get<any>(this.controller + '/GetAMP_Licenses_Pending_Partner_Orders?tenantId=' + tenantId)
      .pipe(catchError(this.authService.handleError));
  }

  public GetAdobeTenants_ForQuotes(): Observable<IAdobeCustomesForQuoting[] | ApiResponse> {
    return this.http.get<IAdobeCustomesForQuoting[] | ApiResponse>(this.controller + '/GetAdobeTenants_ForQuotes')
      .pipe(catchError(this.authService.handleError));
  }

  public AMPPreviewRenewal(tenantId: string, threeYCStartDate: string): Observable<any> {
    return this.http.get<any>(
      this.controller +
      '/AMP_Preview_Renewal?tenantId=' + tenantId +
      (threeYCStartDate ? ('&threeYC_start_date=' + threeYCStartDate) : '')
    ).pipe(catchError(this.authService.handleError));
  }
}
